import { IRefinementGroup, IRefinement } from 'models/filtering/refinement';
import * as c from 'models/constants';
import { setRefinementGroups as setProductRefinementGroups } from './productsearchresults';
import { setRefinementGroups as setWardrobeRefinementGroups } from './wardrobeitemsearchresults';
import { IStore } from 'redux/IStore';
import { ProductFiltering } from '../product/productFiltering';
import { SearchUsage } from 'models/enums/searchusage';

export class ProductBaseSearch {
	private dispatch: any;
	private nodeType: string;
	private usage: SearchUsage;
	private setRefinementGroups: (refinementGroups: any) => void;

	constructor(dispatch: any, nodeType: string, usage?: SearchUsage) {
		this.dispatch = dispatch;
		this.nodeType = nodeType;
		this.usage = usage;

		if (this.nodeType === c.NODE_TYPE_PRODUCT) {
			this.setRefinementGroups = setProductRefinementGroups;
		} else if (this.nodeType === c.NODE_TYPE_WARDROBE) {
			this.setRefinementGroups = setWardrobeRefinementGroups;
		} else if (this.nodeType === c.NODE_TYPE_WISHLIST) {
			this.setRefinementGroups = null;
		}
	}

	public setInitialRefinementsGroups(refinementGroups: IRefinementGroup[]) {
		refinementGroups.forEach((groupElement: IRefinementGroup) => {
			groupElement.refinements.forEach((element: IRefinement) => {
				element.available = true;
				element.disabled = false;
				element.selected = false;
			});
		});

		this.dispatch(this.setRefinementGroups(refinementGroups));
	}

	public filterOutRefinements(refinementGroups: IRefinementGroup[]) {
		return (_, getState: () => IStore) => {
			const productFiltering = this.getFilteringInstance(getState());
			productFiltering.filterOutRefinements(refinementGroups);
		};
	}

	public refineProductSearch(refinementGroupId: number, refinementItemId: number) {
		return (_, getState: () => IStore) => {
			const productFiltering = this.getFilteringInstance(getState());
			productFiltering.refineSearch(refinementGroupId, refinementItemId);
		};
	}

	private getFilteringInstance(state: IStore) {
		let productFiltering = null;
		if (this.nodeType === c.NODE_TYPE_PRODUCT) {
			productFiltering = new ProductFiltering(this.dispatch, state, this.nodeType, this.usage);
		} else if (this.nodeType === c.NODE_TYPE_WARDROBE) {
			productFiltering = new ProductFiltering(this.dispatch, state, this.nodeType, this.usage);
		}
		return productFiltering;
	}
}
